<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-card flat outlined style="border-radius: 12px; border: 1px solid #eaeaea; background: #fff;">
      <div style="padding: 16px 20px; border-bottom: 1px solid #eaeaea; background-color: #fafafa; border-radius: 12px 12px 0 0;">
        <span style="font-family: poppinssemibold; font-size: 15px; color: #1c1c1c;">
          Added Products
        </span>
      </div>

      <!-- List Items (Grid of Cards) -->
      <v-container fluid class="pa-4" v-if="products.length > 0">
        <v-layout wrap>
          <v-flex
            v-for="item in products"
            :key="item._id"
            xs12
            sm6
            md6
            lg6
            xl6
            class="pa-3"
          >
            <product-item v-bind:storage="item" @stepper="winStepper" />
          </v-flex>
        </v-layout>
      </v-container>

      <div v-else style="padding: 24px; text-align: center;">
        <span style="font-family: poppinsregular; font-size: 14px; color: #8d8d8d;">
          No products found
        </span>
      </div>

      <!-- Pagination -->
      <div v-if="pages > 1" style="padding: 12px; border-top: 1px solid #eaeaea; display: flex; justify-content: center;">
        <v-pagination
          v-model="currentPage"
          :length="pages"
          :total-visible="5"
          color="#3ea56e"
          class="sidebar-pagination"
        ></v-pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import ProductItem from "./productitem";

export default {
  name: "ProductList",
  components: {
    ProductItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      currentPage: 1,
      pages: 1,
      count: 5,
      totalCount: 0,
      products: [],
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getData();
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/view/seller/products",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.pages = response.data.pages;
            this.totalCount = response.data.totalcount;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.sidebar-pagination >>> .v-pagination__item {
  font-size: 11px;
  min-width: 28px;
  height: 28px;
}
.sidebar-pagination >>> .v-pagination__navigation {
  width: 28px;
  height: 28px;
}
</style>
